import Splide from '@splidejs/splide';
import { splideTexts } from './splideTexts';
(function ($) {
    $(function () {
        var sliderModule = Array.from(document.querySelectorAll('.slider'));
        if (sliderModule.length === 0)
            return;
        var sliderOptions = {
            type: 'loop',
            lazyLoad: 'nearby',
            arrows: true,
            preloadPages: 3,
            focus: 'center',
            i18n: splideTexts('Bild'),
            gap: 'var(--gutter-width)',
        };
        sliderModule.forEach(function (sliderModule) {
            var splideElement = sliderModule.querySelector('.splide');
            if (!(splideElement instanceof HTMLElement))
                return;
            initSplide(splideElement);
        });
        function initSplide(sliderElement) {
            var splide = new Splide(sliderElement, sliderOptions);
            splide.mount();
        }
    });
})(jQuery);
